export const SET_POP_UP_NOTIFICATION_TEXT = 'SET_POP_UP_NOTIFICATION_TEXT';
